import { AxiosResponse } from "axios";
import RequestUtilitario, { BasicQueryType } from "../../../Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../Axios";
import TituloSituacao from "@/Models/Financeiro/Titulo/TituloSituacao";

export function useListar({
    tituloSituacao,
    ordemMinima,
    ativo
}:BasicQueryType<AxiosResponse<TituloSituacao[]>, {
    tituloSituacao?: TituloSituacao,
    ordemMinima?: number,
    ativo?: boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        tituloSituacao,
        ordemMinima,
        ativo
    });

    return useQuery({
        queryKey : ["Financeiro.Financeiro.Titulo.TituloSituacao.Listar", `Financeiro.Financeiro.Titulo.TituloSituacao.Listar?${queryString}`],
        queryFn : () => Axios.get<TituloSituacao[]>(`financeiro/titulo/titulosituacao?${queryString}`),
        select : ({data}) => data,
        staleTime: 1000 * 60 * 60 // query ficará valida por 1 hora
    });
}